export default __webpack_public_path__ + "static/media/6.32b456d7.jpg";